<app-sidenav
  [items]="items"
  [opened]="opened"
  [userName]="userName"
  [companyLabel]="companyLabel"
  (openedChange)="opened = $event"
  (logout)="onLogout()"
>
  <router-outlet></router-outlet>
</app-sidenav>
